"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { recordChapterReadCompletion } from "@/lib/actions/chapter-read-actions";
import { captureClientEvent } from "@/lib/analytics/client";
export function ChapterReadTracker(t0) {
  const $ = _c(15);
  const {
    storyId,
    chapterId,
    chapterPosition,
    isAuthenticated,
    isOwnStory
  } = t0;
  const completionRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== chapterId || $[1] !== chapterPosition || $[2] !== isAuthenticated || $[3] !== isOwnStory || $[4] !== storyId) {
    t1 = () => {
      if (isOwnStory) {
        return;
      }
      captureClientEvent("chapter_read_started", {
        story_id: storyId,
        chapter_id: chapterId,
        chapter_position: chapterPosition,
        is_authenticated: isAuthenticated
      });
    };
    t2 = [chapterId, chapterPosition, isAuthenticated, isOwnStory, storyId];
    $[0] = chapterId;
    $[1] = chapterPosition;
    $[2] = isAuthenticated;
    $[3] = isOwnStory;
    $[4] = storyId;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[7] !== chapterId || $[8] !== chapterPosition || $[9] !== isAuthenticated || $[10] !== isOwnStory || $[11] !== storyId) {
    t3 = () => {
      const sentinel = completionRef.current;
      if (!sentinel || isOwnStory) {
        return;
      }
      let hasRecorded = false;
      const observer = new IntersectionObserver(entries => {
        if (hasRecorded || !entries.some(_temp)) {
          return;
        }
        hasRecorded = true;
        observer.disconnect();
        recordChapterReadCompletion(storyId, chapterId).catch(_temp2);
        captureClientEvent("chapter_read_completed", {
          story_id: storyId,
          chapter_id: chapterId,
          chapter_position: chapterPosition,
          is_authenticated: isAuthenticated
        });
      }, {
        threshold: 0.75
      });
      observer.observe(sentinel);
      return () => observer.disconnect();
    };
    t4 = [chapterId, chapterPosition, isAuthenticated, isOwnStory, storyId];
    $[7] = chapterId;
    $[8] = chapterPosition;
    $[9] = isAuthenticated;
    $[10] = isOwnStory;
    $[11] = storyId;
    $[12] = t3;
    $[13] = t4;
  } else {
    t3 = $[12];
    t4 = $[13];
  }
  useEffect(t3, t4);
  let t5;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div ref={completionRef} className="mt-12 min-h-px" aria-hidden="true" />;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}
function _temp2() {}
function _temp(entry) {
  return entry.isIntersecting;
}